import SfRegister from './Classes/SfRegister';
new SfRegister();
